import * as React from 'react';

function SvgCursorArrowStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.465 18.293L9.01 5 9 24.638l4.387-4.197 2.576 5.873 4.02-1.763-2.577-5.873 6.06-.386z"
        fill="#fff"
      />
      <path
        d="M23.465 18.293L9.01 5 9 24.638l4.387-4.197 2.576 5.873 4.02-1.763-2.577-5.873 6.06-.386zm-5.128 5.616l-1.732.76-2.792-6.364-3.563 3.409.007-13.87 10.21 9.388-4.921.313 2.791 6.364z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCursorArrowStroke;
